import { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

export default function KnowledgeMetaModal({ file, open, onClose }) {
  const [title, setTitle] = useState('')
  const [description, setDesc] = useState('')
  const [tags, setTags] = useState('')

  useEffect(() => {
    if (open) {
      setTitle('')
      setDesc('')
      setTags('')
    }
  }, [open])

  if (!open || !file) return null

  const handleSubmit = () => {
    onClose({
      ok: true,
      meta: {
        title: title.trim() || file.name,
        description: description.trim(),
        tags: tags.split(',').map(t => t.trim()).filter(Boolean)
      }
    })
  }

  return (
    <AnimatePresence>
      <motion.div
        key="km-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/55 flex items-center justify-center z-[1200]"
        onClick={() => onClose({ ok: false })}
      >
        <motion.div
          key="km-modal"
          initial={{ scale: 0.94, opacity: 0, y: 18 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.96, opacity: 0, y: 10 }}
          transition={{ duration: 0.22 }}
          className="bg-white rounded-2xl w-[92vw] max-w-[520px] shadow-xl flex flex-col overflow-hidden"
          onClick={e => e.stopPropagation()}
        >
          <header className="px-6 py-4 border-b flex items-center justify-between bg-gray-50">
            <h3 className="text-base font-semibold">
              รายละเอียดไฟล์:{' '}
              <span className="text-primary">
                {file.name.length > 32 ? file.name.slice(0, 29) + '…' : file.name}
              </span>
            </h3>
            <button
              className="text-gray-600 hover:text-primary"
              aria-label="Close modal"
              onClick={() => onClose({ ok: false })}
            >
              <X size={18} />
            </button>
          </header>

          <section className="p-6 flex flex-col gap-4">
            <label className="text-sm flex flex-col gap-2">
              ชื่อไฟล์ <small className="text-gray-500">(Title)</small>
              <input
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="ชื่อแสดงผล… (ว่าง = ใช้ชื่อไฟล์)"
                className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary"
              />
            </label>

            <label className="text-sm flex flex-col gap-2">
              รายละเอียด <small className="text-gray-500">(Description)</small>
              <textarea
                rows={4}
                value={description}
                onChange={e => setDesc(e.target.value)}
                placeholder="คำอธิบายเพิ่มเติม…"
                className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary"
              />
            </label>

            <label className="text-sm flex flex-col gap-2">
              แท็ก <small className="text-gray-500">(Tags — คั่นด้วย ,)</small>
              <input
                value={tags}
                onChange={e => setTags(e.target.value)}
                placeholder="tag1, tag2, …"
                className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary"
              />
            </label>
          </section>

          <footer className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">
            <button
              type="button"
              onClick={() => onClose({ ok: false })}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg px-4 py-2 text-sm font-semibold"
            >
              ยกเลิก
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              className="bg-primary hover:bg-secondary text-white rounded-lg px-5 py-2 text-sm font-semibold"
            >
              อัปโหลด
            </button>
          </footer>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}
